import { HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject, runInInjectionContext } from '@angular/core';

import { from, switchMap } from 'rxjs';

import { ClientConfigProductName } from '../client-config/client-config.decorator';
import { ProductService } from '../products/product.service';

export const provideLazyHttpInterceptor: (product: ClientConfigProductName, loaderPromise: () => Promise<HttpInterceptorFn>) => HttpInterceptorFn = (
    product,
    loaderPromise,
) => {
    return (req, next) => {
        const isActiveProduct = inject(ProductService).current.name === product;

        if (!isActiveProduct) {
            return next(req);
        }

        const injector = inject(Injector);

        return from(loaderPromise()).pipe(switchMap((handler) => runInInjectionContext(injector, () => handler(req, next))));
    };
};
